import { Outlet } from "react-router-dom";
import DataAccessNotice from "@/components/dataAccess/DataAccessNotice";
import Sidebar from "@/components/sidebar/Sidebar";

/**
 * Signed-in shell: the navigation rail on the left (desktop) and the page in
 * the remaining space. On phones the rail is hidden and the slim top bar
 * (Header) carries the navigation, so only there the page starts below it.
 */
const DashboardView = () => (
  <div className="flex h-screen w-full overflow-hidden pt-14 md:pt-0">
    {/* No overflow on the rail's wrapper: its tooltips and menu open to the right. */}
    <div className="relative z-40 hidden h-full shrink-0 md:block">
      <Sidebar />
    </div>

    {/* isolate: page layers (map panels, the Scenarios rail) stay below the rail's menu and tooltips. */}
    <div className="isolate min-h-0 flex-1 overflow-y-auto bg-canvas">
      <Outlet />
    </div>

    <DataAccessNotice />
  </div>
);

export default DashboardView;
